import styled, { keyframes } from 'styled-components';
const animatedGradientAnimation = keyframes `
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;
export const AnimatedBackground = styled.div `
  background: linear-gradient(-45deg, #F6F6F6, #F1F1F1 , #F7F4F4, #FBFBFB );
  background-size: 400% 400%;
  animation: ${animatedGradientAnimation} 3s ease infinite;
`;
export const ProductTilePlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: column;
  flex-grow: 2;
  flex-basis: 33%;
  max-width: 322px;
  min-height: 380px;
  background-color: #FFF;
  margin: 10px 10px 10px;
`;
export const ProductTilePlaceholderImageWrapper = styled(AnimatedBackground) `
  margin: 15px 15px 0 15px;
  flex-grow: 2;
  border-radius: 5px;
  background-color: ${props => props.theme.colors.borderLight};
`;
export const ProductTilePlaceholderMangeWrapper = styled.div `display:flex;flex-flow:row nowrap;height:46px;`;
export const ProductTilePlaceholderManageButton = styled(AnimatedBackground) `
  flex-grow: 2;
  margin: 10px 15px;
  border-radius: 5px;
  background-color: ${props => props.theme.colors.borderLight}
`;
export const CategoryTreePlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: column;
  width: 245px;
`;
export const CategoryTreeEntry = styled(AnimatedBackground) `
  border-radius: 3px;
  width: 100%;
  height: 25px;
  margin-bottom: 20px;
`;
export const CategoryDescriptionPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: column;
`;
export const CategoryDescriptionPlaceholderText = styled(AnimatedBackground) `
  width: 100%;
  height: 25px;
  margin-bottom: 25px;
`;
export const CategoryManageBarPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  padding: 2rem 0;
`;
export const CategoryManageBarBox = styled(AnimatedBackground) `
  width: 100px;
  height: 30px;
  border-radius: 3px;
`;
export const CategoryProductsWrapperPlaceholder = styled.div `
  display: flex;
  flex-flow: row wrap;
`;
export const ProductRowPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: row nowrap;
  height: 245px;
  width: 100%;
  margin-bottom: 3rem;
`;
export const ProductRowPlaceholderImageWrapper = styled(AnimatedBackground) `
  margin: 0px 15px 0 15px;
  flex-grow: 2;
  border-radius: 5px;
  max-width: 245px;
  background-color: ${props => props.theme.colors.borderLight};
`;
export const ProductRowInfoWrapper = styled.div `display:flex;flex-flow:column;flex-grow:2;`;
export const ProductRowInfoHighlight = styled(CategoryDescriptionPlaceholderText) ``;
export const CategoryFiltersPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: row wrap;
  margin: 1rem 0;
`;
export const CategoryFilterPlaceholderBox = styled(AnimatedBackground) `
  width: 120px;
  height: 42px;
  margin: 0 .75rem .75rem 0;
  ${props => props.theme.mixins.mobile(`
    width: 30%;
    height: 30px;
  `)}
`;
export const ProductPagePlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: row wrap;
  margin: 2rem 10rem 4rem 10rem;
  ${props => props.theme.mixins.mobile(`
    margin: 0;
    flex-flow: column;
  `)}
`;
export const ProductGalleryPlaceholderWrapper = styled.div ``;
export const ProductGalleryPlaceholder = styled(AnimatedBackground) `
  width: 600px;
  height: 450px;
  margin: 1rem;
  ${props => props.theme.mixins.mobile(`
    width: calc(100% - 2rem);
    height: 250px;
  `)}
`;
export const ProductGalleryThumbnailsPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: row nowrap;
`;
export const ProductGalleryThumbnailPlaceholder = styled(AnimatedBackground) `
  width: 150px;
  height: 100px;
  margin: 1rem;
`;
export const ProductInfoPlaceholderWrapper = styled.div `
  display: flex;
  flex-flow: column;
  max-width: 400px;
  flex-grow: 2;
  margin: 1rem;
`;
export const ProductInfoRow = styled(AnimatedBackground) `
  width: 100%;
  height: 30px;
  margin-bottom: 1rem;
`;
export const ProductPageTabsPlaceholder = styled.div `
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  margin-bottom: 10rem;
`;
export const ProductTabPlaceholder = styled(AnimatedBackground) `
  width: 100px;
  height: 20px;
  margin: 0 1rem;
`;
